import {colors} from 'shells/colors/colors';
import {ChatBubbleDoubleRegularIcon} from 'shells/icon/svg/chat-bubble-double-regular-icon';

import {ContactFilter} from 'nutshell-graphql-types';

import type {LegendItemProps} from './legend-item';

export const TAB_OPTIONS: {id: ContactFilter; label: string}[] = [
    {id: ContactFilter.ALL, label: 'All threads'},
    {id: ContactFilter.NO_CONTACT, label: 'Unidentified threads'},
];

export const DEFAULT_CHATBOT_REPORT_PERIOD = '-d30';

export const LEGEND_ITEMS: LegendItemProps[] = [
    {color: colors.green!, label: 'Good threads'},
    {color: colors.greyXlt!, label: 'Neutral threads'},
    {color: colors.red!, label: 'Bad threads'},
];

export const GOOD_SECTION_DEFAULTS = {
    color: colors.green!,
    label: 'Good',
    labelColor: colors.black!,
} as const;

export const BAD_SECTION_DEFAULTS = {
    color: colors.red!,
    label: 'Bad',
    labelColor: colors.black!,
} as const;

export const NEUTRAL_SECTION_DEFAULTS = {
    color: colors.greyXlt!,
    label: 'Neutral',
    labelColor: colors.black!,
} as const;

export const LEADERBOARD_EMPTY_STATE_PROPS = {
    text: 'No topics found',
    icon: ChatBubbleDoubleRegularIcon,
    iconSize: 24,
} as const;

export const NUDGES_EMPTY_STATE_PROPS = {
    text: 'All conversations during this period were visitor-initiated',
    icon: ChatBubbleDoubleRegularIcon,
    iconSize: 24,
} as const;

export const THREAD_SIDEBAR_OPEN_SOURCES = {
    CHATBOT_FEEDBACK_SECTION: 'chatbot-feedback-section',
    ODDBALL_THREADS_SECTION: 'oddball-threads-section',
    KNOWLEDGE_GAPS_SECTION: 'knowledge-gaps-section',
    TOP_NUDGES_SECTION: 'top-nudges-section',
    TOPICS_SECTION: 'topics-section',
} as const;

export type ThreadSidebarOpenSource =
    (typeof THREAD_SIDEBAR_OPEN_SOURCES)[keyof typeof THREAD_SIDEBAR_OPEN_SOURCES];

export const EMPTY_STATE_SECTION_DEFAULTS = {
    color: colors.greyXlt!,
    label: 'No threads',
    labelColor: colors.black!,
    value: 0,
} as const;
